import { initObservability } from "@freightsimple/observability/observability";
import { apiServerUrl, environment, isLocal } from "../environment";

if (!isLocal()) {
  initObservability({
    serviceName: "hubble",
    environment,
    apiBaseUrl: apiServerUrl(),
  });
}
